import React, { useRef } from "react";
import { RiSendPlaneLine } from "react-icons/ri";
import generateResponse from "../utilities/generateResponse";
import generateAiResponse from "../utilities/generateAIResponse";

const ChatInput = ({
	siteTheme,
	isDay,
	messages,
	fallback,
	chatType,
	setMessages,
	aiResponses,
	greetingResponses,
}) => {
	const inputRef = useRef();

	function handleSubmit(e) {
		e.preventDefault();
		const userMessage = inputRef?.current?.value?.trim();
		if (!userMessage) return;

		setMessages((prev) => [
			...prev,
			{ text: userMessage, role: "user", timestamp: Date.now() },
		]);

		const aiID = setTimeout(() => {
			//  Analysis what the user message is and get response from AI
			setMessages((prev) => [
				...prev,
				{ text: "Thinking...", role: "model", timestamp: Date.now() },
			]);

			if (chatType === "ChatBot") {
				generateResponse(
					userMessage,
					setMessages,
					fallback,
					greetingResponses,
					aiResponses
				);
			} else {
				generateAiResponse(
					[...messages, { role: "user", text: userMessage }],
					setMessages
				);
			}
		}, 500);

		inputRef.current.value = "";

		return () => clearTimeout(aiID);
	}

	return (
		<div
			className={`${siteTheme.borderColor} ${siteTheme.headingBackground} ease-in duration-300 absolute bottom-0 text-brandBlack border-[0.5px] w-full flex items-center justify-between overflow-hidden p-1 pr-3`}>
			<input
				ref={inputRef}
				type="text"
				name="message"
				placeholder={
					chatType === "ChatBot"
						? `How can ${chatType} assist ?`
						: `<<-- How can ${chatType} assist ? -->>`
				}
				className={`${siteTheme.textColor} ${
					chatType === "ChatBot"
						? ""
						: "placeholder:text-green-600 text-green-600"
				} w-full text-sm font-semibold tracking-wider bg-transparent border-none outline-none focus:outline-none focus:border-none focus:ring-0`}
				id="message"
				required
				autocomplete="off"
			/>
			<RiSendPlaneLine
				size={25}
				color={
					isDay
						? chatType === "ChatBot"
							? "#171e25"
							: " #38a169"
						: chatType === "ChatBot"
						? "#fff"
						: " #38a169"
				}
				className="cursor-pointer"
				onClick={handleSubmit}
			/>
		</div>
	);
};

export default ChatInput;
